"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "AnalyticsWebClient", {
  enumerable: true,
  get: function get() {
    return _analyticsWebClient["default"];
  }
});
exports.CommunityAnalyticsClient = void 0;
var _analyticsWebClient = _interopRequireWildcard(require("@atlassiansox/analytics-web-client"));
var _atlCrossDomainTracking = require("@atlassian/atl-cross-domain-tracking");
var _environment = require("../../utils/environment");
var _initializer = require("../atl-analytics/initializer");
var _tracking = require("../atl-analytics/tracking");
var _gasv = require("../atl-analytics/gasv3");
var _identity = require("../atl-analytics/identity");
var _types = require("./types");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * Service to interact with analytics client, send GASv3 events
 */
var CommunityAnalyticsClient = exports.CommunityAnalyticsClient = /*#__PURE__*/function () {
  function CommunityAnalyticsClient() {
    _classCallCheck(this, CommunityAnalyticsClient);
  }
  return _createClass(CommunityAnalyticsClient, null, [{
    key: "init",
    value: function init() {
      var _this = this;
      if (typeof window !== 'undefined') {
        var settings = _objectSpread({
          useStargate: (0, _environment.shouldUseStargate)(this.clientEnvironment),
          xidConsent: true,
          xidPromiseFn: function xidPromiseFn() {
            return new _atlCrossDomainTracking.XID((0, _environment.getXidEnvironment)(_this.clientEnvironment)).getXidCallbackForPromise();
          }
        }, this.clientSettings);
        return new _analyticsWebClient["default"]({
          env: (0, _environment.getGASv3Environment)(this.clientEnvironment),
          product: this.PRODUCT,
          version: '1.0.0',
          locale: 'en-us'
        }, settings);
      }
      throw new Error('window is not defined');
    }

    /**
     * Initializes the analytics web client without auto-tracking and page views
     * @param communitySubApp the current community sub-app sending events (value will be sent in the `subApp` attribute on events)
     * @param settings optional, any analytics settings to override (or null, to use default settings)
     * @param environment optional, the environment to use (or null, to use default environment-fetching logic)
     * @param userId optional, the userId to set on the analytics client
     */
  }, {
    key: "initializeClient",
    value: function initializeClient(communitySubApp, settings, environment) {
      var userId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var writeKey = (0, _environment.getAnalyticsWriteKey)(this.clientEnvironment);
      this.writeKey = writeKey;
      this.clientSettings = settings;
      this.clientEnvironment = environment;
      this.analyticsClient = this.init();

      // set static analytics client instance on GASv3 class
      _gasv.GASv3.client = this.analyticsClient;

      // TODO: change this (currently sets AAID from identity cookie on client)
      var clientUserId = userId || _identity.Identity.getAtlassianUserId();
      if (clientUserId) {
        this.setAnalyticsUserInfo(clientUserId);
      }

      // set global community attributes to be sent on each event
      _gasv.GASv3.additionalEventData = this.getGlobalAttributes(communitySubApp);
      return this.analyticsClient;
    }

    /**
     * Initializes the analytics web client and auto-tracking with page views; returns the client instance
     * @param communitySubApp the current community sub-app sending events (value will be sent in the `subApp` attribute on events)
     * @param settings optional, any analytics settings to override (or null, to use default settings)
     * @param environment optional, the environment to use (or null, to use default environment-fetching logic)
     * @param {object} pageViewProperties - optional, dictionary of properties of the page
     * @param userId optional, the userId to set on the analytics client
     */
  }, {
    key: "initWithPageAnalytics",
    value: function initWithPageAnalytics(communitySubApp, settings, environment) {
      var pageViewProperties = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var userId = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
      if (!this.analyticsClient) {
        this.analyticsClient = this.initializeClient(communitySubApp, settings, environment, userId);
      }
      this.setUpPageAnalytics(pageViewProperties);
      return this.analyticsClient;
    }

    /**
     * Sets up auto-tracking and page analytics for the current page view
     * @param {object} pageViewProperties - optional, dictionary of properties of the page
     */
  }, {
    key: "setUpPageAnalytics",
    value: function setUpPageAnalytics() {
      var pageViewProperties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!this.analyticsClient) {
        throw new Error('Initialize the analytics client before calling setUpPageAnalytics()');
      }
      // set up auto-tracking for page views and other activity
      _initializer.Initializer.initWithPageAnalytics((0, _environment.getAnalyticsWriteKey)(this.clientEnvironment), deepClone(pageViewProperties), Date.now(), this.analyticsClient.getAnonymousId(), null // createAnalyticsEvent only needed for analytics-next
      );
    }
  }, {
    key: "hasAnalyticsClient",
    value: function hasAnalyticsClient() {
      return !!this.analyticsClient;
    }
  }, {
    key: "getAnalyticsClient",
    value: function getAnalyticsClient() {
      return this.analyticsClient;
    }
  }, {
    key: "setAnalyticsUserInfo",
    value: function setAnalyticsUserInfo(userId) {
      if (userId && this.hasAnalyticsClient()) {
        this.getAnalyticsClient().setUserInfo(_analyticsWebClient.userType.ATLASSIAN_ACCOUNT, userId);
      }
    }

    /**
     * Sends a GASv3 event to the analytics client
     * @param type the type of event to send (UI, SCREEN, TRACK, OPERATIONAL), by default UI
     * @param payload the event payload
     * TODO: Change type of payload
     */
  }, {
    key: "sendEvent",
    value: function sendEvent() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _types.eventType.UI;
      var payload = arguments.length > 1 ? arguments[1] : undefined;
      if (this.isAnalyticsEnabled()) {
        _tracking.Tracking.trackEvent('', payload, type);
      }
    }

    /**
     * Returns global attributes for community
     * @param subApp current community sub-app sending events
     */
  }, {
    key: "getGlobalAttributes",
    value: function getGlobalAttributes(subApp) {
      return {
        app: this.APP,
        subApp: subApp
      };
    }
  }]);
}();
/** Payload for eventType.UI and TRACK events
 * @property {string} action - action being performed
 * @property {string} actionSubject - subject of the action
 * @property {string} [actionSubjectId] - (optional) action subject id
 * @property {Record<string, string>} [attributes] - (optional) additional attributes
 * @property {string} [source] - source of the event, where (e.g. a screen) in the product
 */
_defineProperty(CommunityAnalyticsClient, "PRODUCT", 'marketing');
_defineProperty(CommunityAnalyticsClient, "APP", 'community');
_defineProperty(CommunityAnalyticsClient, "SUB_APP", {
  HOME: 'home',
  FORUMS: 'forums',
  LEARNING: 'learning',
  EVENTS: 'events',
  UNIFIED_PORTABLE_PROFILE: 'unified-portable-profile'
});
_defineProperty(CommunityAnalyticsClient, "writeKey", null);
_defineProperty(CommunityAnalyticsClient, "analyticsClient", null);
_defineProperty(CommunityAnalyticsClient, "clientSettings", null);
_defineProperty(CommunityAnalyticsClient, "clientEnvironment", null);
_defineProperty(CommunityAnalyticsClient, "isAnalyticsEnabled", function () {
  return true;
});
/**
 * Payload for eventType.SCREEN events
 * @property {string} name - name of the screen being viewed
 * @property {Record<string, string>} [attributes] - additional attributes
 */
// type constrained to community sub-app string values (as defined by CommunityAnalyticsClient.SUB_APP)
var deepClone = function deepClone(obj) {
  return JSON.parse(JSON.stringify(obj));
};